import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const RedirectHandler = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const status = searchParams.get("status");
    const aadhaar = searchParams.get("aadhaar");

    if (status === "success") {
      if (aadhaar) {
        localStorage.setItem("aadhaar_number", aadhaar);
      }
      navigate("/user_kyc"); // Or reload same KYC form
    } else {
      navigate("/kyc-failure");
    }
  }, []);

  return <div>Verifying Aadhaar, please wait...</div>;
};

export default RedirectHandler;
